import {Injectable, EventEmitter} from '@angular/core';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:AnimateService'));

/**
 * Simple animation method
 * No need to load anything fancy just to do basic animations
 */
@Injectable()
export class AnimateService {

    constructor() {
        // 'Construct Animate' );
    }

    /** @since 1.0.0 */
    public start (start, end, time, easing, callback, timeouts?, name?) {

        debugOff( 'Start animate' );
        debugOff( 'Start:', start );
        debugOff( 'End:', end );
        debugOff( 'Easing:', easing );

        var count = 0,
            change = end - start,
            fps = 60,
            max = fps / (1000 / time),
            curr = start;

        typeof time === 'undefined' && (time = 1000);
        typeof easing === 'undefined' && (easing = 'easingInOutQuad');
        typeof callback === 'undefined' && (callback = function () { });
        typeof timeouts === 'undefined' && (timeouts = {});
        typeof timeouts === 'undefined' && (name = 'animate');

        if (time === 0) { callback(end, count, max); return; }

        cancelAnimationFrame(timeouts[name]);
        runAnimate(start, easing, callback, timeouts, name, count, change, max, curr);

        function runAnimate(start, easing, callback, timeouts, name, count, change, max, curr) {
            if ((curr - start) != change) {
                timeouts[name] = requestAnimationFrame(function () {
                    runAnimate(start, easing, callback, timeouts, name, count, change, max, curr);
                });
                if (easing == 'linearEase') {
                    curr = change * count / max + start;
                } else if (easing == 'easeInQuad') {
                    curr = change * (count / max) * (count / max) + start;
                } else if (easing == 'easeOutQuad') {
                    curr = (-change * (count / max) * (count / max - 2) + start);
                } else if (easing == 'easeInCubic') {
                    curr = change * Math.pow(count / max, 3) + start;
                } else if (easing == 'easeOutCubic') {
                    curr = change * (Math.pow(count / max - 1, 3) + 1) + start;
                } else if (easing == 'easeInOutQuad') {
                    if ((count / (max / 2)) < 1) {
                        curr = change / 2 * (count / (max / 2)) * (count / (max / 2)) + start;
                    } else {
                        curr = -change / 2 * (((count / (max / 2)) - 1) * ((count / (max / 2)) - 3) - 1) + start;
                    }
                } else if (easing == 'easeInOutCubic') {
                    if ((count / (max / 2)) < 1) {
                        curr = change / 2 * Math.pow((count / (max / 2)), 3) + start;
                    } else {
                        curr = change / 2 * (Math.pow((count / (max / 2)) - 2, 3) + 2) + start;
                    }
                }
                callback(curr, count, max);
                count++;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/services/animate-service.ts